module.exports = __webpack_public_path__ + "static/simic-hybrid-3-e627c16cadd0a9b8edb0d5ffd42d8d8d.png";